
import {
	CheckCircleOutlined,
	CheckCircleSolid,
	ExclamationCircleOutlined,
	ExclamationCircleSolid,
	ExclamationOutlined,
	CheckOutlined,
	InformationCircleOutlined,
	InformationCircleSolid,
} from '@/assets/svgs/DesignSystem/status';
import {
	MaximizeOutlined,
	MinimizeOutlined,
	ChevronDownOutlined,
	ChevronUpOutlined,
	ChevronLeftOutlined,
	ChevronRightOutlined,
	ArrowSmallDownOutlined,
	ArrowsUpDownOutlined,
	EllipsisVerticalOutlined
} from '@/assets/svgs/DesignSystem/navigation';
import { IconStyle } from '@/componentsDS/Icon/Icon.type';
import { NotificationSettingsOutlined, NotificationSettingsSolid } from '@/assets/svgs/DesignSystem/system';
import { XMarkOutlined, MinusOutlined, EditPenOutlined, EditPenSolid } from '@/assets/svgs/DesignSystem/general-tool';

const iconMap = {
	'check-circle': {
		[IconStyle.OUTLINED]: CheckCircleOutlined,
		[IconStyle.SOLID]: CheckCircleSolid
	},
	'exclamation-circle': {
		[IconStyle.OUTLINED]: ExclamationCircleOutlined,
		[IconStyle.SOLID]: ExclamationCircleSolid
	},
	'information-circle': {
		[IconStyle.OUTLINED]: InformationCircleOutlined,
		[IconStyle.SOLID]: InformationCircleSolid
	},
	'maximize': {
		[IconStyle.OUTLINED]: MaximizeOutlined,
		[IconStyle.SOLID]: MaximizeOutlined
	},
	'minimize': {
		[IconStyle.OUTLINED]: MinimizeOutlined,
		[IconStyle.SOLID]: MinimizeOutlined
	},
	exclamation: {
		[IconStyle.OUTLINED]: ExclamationOutlined,
		[IconStyle.SOLID]: ExclamationOutlined
	},
	'chevron-down': {
		[IconStyle.OUTLINED]: ChevronDownOutlined,
		[IconStyle.SOLID]: ChevronDownOutlined
	},
	'chevron-up': {
		[IconStyle.OUTLINED]: ChevronUpOutlined,
		[IconStyle.SOLID]: ChevronUpOutlined
	},
	'chevron-left': {
		[IconStyle.OUTLINED]: ChevronLeftOutlined,
		[IconStyle.SOLID]: ChevronLeftOutlined
	},
	'chevron-right': {
		[IconStyle.OUTLINED]: ChevronRightOutlined,
		[IconStyle.SOLID]: ChevronRightOutlined
	},
	'arrow-small-down': {
		[IconStyle.OUTLINED]: ArrowSmallDownOutlined,
		[IconStyle.SOLID]: ArrowSmallDownOutlined
	},
	'arrows-up-down': {
		[IconStyle.OUTLINED]: ArrowsUpDownOutlined,
		[IconStyle.SOLID]: ArrowsUpDownOutlined
	},
	'ellipsis-vertical': {
		[IconStyle.OUTLINED]: EllipsisVerticalOutlined,
		[IconStyle.SOLID]: EllipsisVerticalOutlined
	},
	'edit-pen': {
		[IconStyle.OUTLINED]: EditPenOutlined,
		[IconStyle.SOLID]: EditPenSolid
	},
	'notification-settings': {
		[IconStyle.OUTLINED]: NotificationSettingsOutlined,
		[IconStyle.SOLID]: NotificationSettingsSolid
	},
	'x-mark': {
		[IconStyle.OUTLINED]: XMarkOutlined,
		[IconStyle.SOLID]: XMarkOutlined
	},
	minus: {
		outlined: MinusOutlined,
		solid: MinusOutlined
	},
	check: {
		outlined: CheckOutlined,
		solid: CheckOutlined
	},
};

export default iconMap;
